import { render, staticRenderFns } from "./JsonHistory.vue?vue&type=template&id=5cd7d07f&scoped=true"
import script from "./JsonHistory.vue?vue&type=script&lang=js"
export * from "./JsonHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd7d07f",
  null
  
)

export default component.exports